<template>
    <div style="margin-top:-30px">
        <div>
            <!-- <div style="display:flex">
                <h4>New Payment Schedule</h4>
            </div> -->
            <div style="padding-left: 10px;">
                <div class="row">
                    <div class="col-sm-5" style="padding:10px">
                        <div style="background-color:#fafbfc;padding:10px;height:100%">
                            <div>
                                <h4>Information</h4>
                            </div>
                            <base-input label="Description" class="range-picker">
                                <el-input :disabled="type!='edit'" v-model="paymentScheduleForm.description" style="background-color: #f5f5f5;color: #685b51;" />
                            </base-input>
                            <div style="position:absolute;right:20px;text-align:right" v-if="numberOfSchedule!=0">No. of Days: {{numberOfSchedule}}</div>
                            <base-input label="Schedule Period" class="range-picker">
                                <el-date-picker
                                    type="daterange"
                                    placeholder="Schedule Period"
                                    v-model="paymentScheduleForm.campaignPeriod"
                                    class = "form-control"
                                    :disabled-date="val=>disabledDate(val)"
                                    :disabled="type!='edit'"
                                >
                                </el-date-picker>
                            </base-input>
                            <div class="row">
                                <div class="col-sm-6">
                                    <base-input label="Schedule Media Amount" class="range-picker">
                                        <money-input :disabled="type!='edit'" :model="paymentScheduleForm.mediaTotal" v-model="paymentScheduleForm.mediaTotal" style="background-color: #f5f5f5;color: #685b51;"/>
                                    </base-input>
                                </div>
                                <div class="col-sm-6">
                                    <base-input label="Schedule Production Amount" class="range-picker">
                                        <money-input :disabled="type!='edit'" :model="paymentScheduleForm.productionTotal" v-model="paymentScheduleForm.productionTotal" style="background-color: #f5f5f5;color: #685b51;"/>
                                    </base-input>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <base-input label="Total Schedule Amount" class="range-picker" disabled>
                                        <money-input :model="paymentScheduleForm.grandTotal" v-model="paymentScheduleForm.grandTotal" style="background-color: #f5f5f5;color: #685b51;" disabled/>
                                    </base-input>
                                </div>
                            </div>
                            <!-- <base-input label="Contract Campaign Period">
                                <el-input value="01/08/2022 - 31/08/2022"
                                    style="background-color: #f5f5f5;color: #685b51;" />
                            </base-input> -->
                        </div>
                        
                    </div>
                    <div class="col-sm-4" style="padding:10px">
                        <div style="background-color:#fafbfc;padding:10px;height:100%">
                            <div>
                                <h4>Schedule Setting</h4>
                            </div>
                            <base-input label="Payment Type" class="range-picker">
                                <el-select
                                    class="select-primary"
                                    size="large"
                                    placeholder="Payment Type"
                                    v-model="paymentScheduleForm.paymentType"
                                    filterable
                                    style="width: 100%"
                                    :disabled="type!='edit'"
                                >
                                    <el-option v-for="item in paymentType" :key="item" :label="item.Name" :value="item.Code"></el-option>
                                </el-select>
                            </base-input>
                            <div class="row" v-if="paymentScheduleForm.paymentType=='installment'">
                                <div class="col-sm-6">
                                    <label style="margin-bottom:0px">Mode</label>
                                    <el-radio-group v-model="installmentMode" class="ml-4" :disabled="type!='edit'">
                                        <el-radio label="month" size="large">Month</el-radio>
                                        <el-radio label="day" size="large">Day</el-radio>
                                    </el-radio-group>
                                    <!-- <div>
                                        <base-radio style="width:100%" v-model="installmentMode">Month</base-radio>
                                        <base-radio style="width:100%" v-model="">Day</base-radio>
                                    </div> -->
                                </div>
                                <div class="col-sm-12">
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <base-input :label="installmentTitle" class="range-picker" >
                                                <el-input style="background-color: #f5f5f5;color: #685b51;" v-model="installmentNumberOf" :disabled="type!='edit'"/>
                                            </base-input>
                                        </div>
                                        <div class="col-sm-6">
                                            <base-input label="Early Deposit" class="range-picker" >
                                                <el-input style="background-color: #f5f5f5;color: #685b51;" v-model="earlyDeposit" :disabled="type!='edit'"/>
                                            </base-input>
                                        </div>
                                    </div>
                                    
                                    
                                </div>
                                <div class="col-sm-12">
                                    <label style="margin-bottom:0px">Split Preference</label>
                                    <el-radio-group v-model="splitPref" class="ml-4" :disabled="type!='edit'">
                                        <el-radio label="ssd" size="large">Same Date of SSD</el-radio>
                                        <el-radio label="fix" size="large" :disabled="installmentMode=='day'">Fix Date of Month<el-input size="small" v-model="fixDate" :disabled="installmentMode=='day'||splitPref=='ssd'" style="width:30%;margin-left:10px"></el-input></el-radio>
                                    </el-radio-group>
                                    <!-- <div>
                                        <base-radio style="width:100%">Same Date of SSD</base-radio>
                                        <base-radio style="width:100%">Fix Date of Month</base-radio>
                                    </div> -->
                                </div>
                            </div>
                            <!-- <base-input label="Contract Campaign Period">
                                <el-input value="01/08/2022 - 31/08/2022"
                                    style="background-color: #f5f5f5;color: #685b51;" />
                            </base-input> -->
                        </div>
                        
                    </div>
                    <div class="col-sm-3" style="padding:10px">
                        <div style="background-color:#fafbfc;padding:10px;height:100%">
                            <div>
                                <h4>Terms
                                    <el-popover
                                        placement="bottom"
                                        title="Terms"
                                        :width="320"
                                        trigger="hover"
                                        content="this is content, this is content, this is content"
                                    >
                                        <template #reference>
                                            <el-icon style="position:relative;top:3px"><Warning /></el-icon>
                                            <!-- <el-button>Hover to activate</el-button> -->
                                        </template>
                                        <template #default>
                                            <div class="term-description">
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <div class="title">Short Code</div>
                                                        <div>COD:</div>
                                                        <div>SSD:</div>
                                                        <div>SED:</div>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <div class="title">Description</div>
                                                        <div>Cash On Delivery</div>
                                                        <div>Schedule Period - Start Date</div>
                                                        <div>Schedule Period - End Date</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </el-popover>
                                </h4>
                            </div>
                            <base-input label="Payment Term" class="range-picker">
                                <el-select
                                    class="select-primary"
                                    size="large"
                                    placeholder="Payment Term"
                                    v-model="paymentScheduleForm.paymentTerm"
                                    filterable
                                    style="width: 100%"
                                    :disabled="isPrivate || type!='edit'"
                                >
                                    <el-option v-for="item in paymentTerm" :key="item" :label="item.Name" :value="item.Code"></el-option>
                                </el-select>
                            </base-input>
                            <base-input label="Invoice Term" class="range-picker">
                                <el-select
                                    class="select-primary"
                                    size="large"
                                    placeholder="Invoice Term"
                                    v-model="paymentScheduleForm.invoiceTerm"
                                    filterable
                                    style="width: 100%"
                                    :disabled="isPrivate || type!='edit'"
                                >
                                    <el-option v-for="item in invoiceTerm" :key="item" :label="item.Name" :value="item.Code"></el-option>
                                </el-select>
                            </base-input>
                            <!-- <base-input label="Special Payment Term" class="range-picker">
                                <div class="row">
                                    <div class="col-sm-2">
                                        <base-checkbox v-model="specialTerms">&nbsp;</base-checkbox>
                                    </div>
                                    <div class="col-sm-5">
                                        <el-select
                                            class="select-primary"
                                            size="large"
                                            placeholder=""
                                            v-model="searchForm.specialTermType"
                                            filterable
                                            style="width: 100%"
                                            :disabled="!specialTerms"
                                        >
                                            <el-option label="SSD" value="ssd"></el-option>
                                            <el-option label="SED" value="sed"></el-option>
                                        </el-select>
                                    </div>
                                    <div class="col-sm-5">
                                        <el-input type="number" :formatter="(value) => value<=1?1:value" :disabled="!specialTerms" v-model="searchForm.specialTermDays" class="special-terms-days"></el-input>
                                    </div>
                                </div>
                                
                                
                            </base-input> -->
                            <!-- <base-input label="Contract Campaign Period">
                                <el-input value="01/08/2022 - 31/08/2022"
                                    style="background-color: #f5f5f5;color: #685b51;" />
                            </base-input> -->

                        </div>
                        
                    </div>
                    <div class="col-sm-6" style="margin-top:10px">
                        <el-button type="primary" @click="generateSchedule()" :disabled="type=='view'">Regenerate</el-button>
                        <el-dropdown :disabled="disabled" trigger="click" class="round-dropdown" style="margin-left:20px"  v-if="false">
                            <span class="arrow-down">
                                Re-group
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item>Regroup with Outstanding</el-dropdown-item>
                                    <el-dropdown-item>Regroup with New Schedule</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </div>
                </div>
                <!-- <div class="row">
                    <div class="col-sm-5">
                        <base-input label="Total Media Amount">
                            <el-input value="$30,303.03" style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input>
                    </div>
                    <div class="col-sm-5">
                        <base-input label="Total Outstanding Media Amount">
                            <el-input value="$30,303.03" style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input>
                    </div>
                </div> -->
                <!-- <div class="row">
                    <div class="col-sm-5">
                        <base-input label="Total Production Amount">
                            <el-input value="$15,000.00" style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input>
                    </div>
                    <div class="col-sm-5">
                        <base-input label="Total Outstanding Production Amount">
                            <el-input value="$15,000.00" style="background-color: #f5f5f5;color: #685b51;" />
                        </base-input>
                    </div>
                </div> -->

                <div style="padding-top: 30px;padding-bottom:5px;  border-bottom: solid 1px #e3e3e3;">
                    <el-button type="primary" @click="NewOrder" :disabled="isNew"> + Add Schedule </el-button>
                    <!-- <label @click="addPaymentSchedule"><span class="add-button" style="background-color: #eb6100"> +
                    </span> Add Payment Schedule</label> -->
                </div>
                <el-table :data="scheduleData" class-name="schedule-table">
                    <!-- <el-table-column type="No." label="No."  width="50"/> -->

                    <el-table-column width="50">
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                    <el-table-column width="30">
                        <template #default="prop">

                            <base-checkbox v-if="!prop.row.isTotal">&nbsp;</base-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="No" width="30" prop="no">

                    </el-table-column>
                    <el-table-column label="Schedule" min-width="70" prop="schedule"/>
                    <el-table-column label="From" min-width="60" prop="from"/>
                    <el-table-column label="To" min-width="60" prop="to"/>
                    <el-table-column :label="getNumberOfTitle()" min-width="35" prop="days"/>
                    <el-table-column label="Installment(Media)" min-width="150" class-name="grey-background" prop="mediaAmount"/>
                    <el-table-column label="Installment(Production)" min-width="150" class-name="grey-background" prop="productionAmount" >
                    </el-table-column>
                    <el-table-column label="Total Amount" min-width="150" class-name="grey-background"  prop="totalAmount"/>
                    <el-table-column label="Payment Due" min-width="80" prop="paymentDueDate">

                    </el-table-column>
                    <el-table-column label="INV Issue Date" min-width="70" prop="invoiceDate">

                    </el-table-column>
                    <el-table-column label="Payment Status" min-width="70" prop="paymentStatus">
                        <template slot-scope="scope" #default="prop">
                            {{displayStatus(prop.row.from)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="Invoice Status" min-width="70" class-name="orange-text" prop="invoiceStatus">
                        <template slot-scope="scope" #default="prop">
                            {{displayInvoiceStatus(prop.row.invoiceStatus)}}
                        </template>
                    </el-table-column>
                    <el-table-column width="50">
                        <template slot-scope="scope">

                        </template>
                    </el-table-column>
                </el-table>
                <el-dropdown :disabled="disabled" trigger="click" class="round-dropdown" style="margin-top:20px" v-if="false">
                    <span class="arrow-down" >
                        Bulk Action
                        <!-- <el-icon><CaretBottom /></el-icon> -->
                    </span>
                    <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item>Break Even</el-dropdown-item>
                        <el-dropdown-item :disabled="isNew">Delete</el-dropdown-item>
                        <el-dropdown-item>Merge</el-dropdown-item>
                        <el-dropdown-item>Lock Schedule</el-dropdown-item>
                        <el-dropdown-item>Un-lock Schedule</el-dropdown-item>
                    </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>

<script setup>
    import baseInput from "@/components/newUI/Inputs/BaseInput";
    import baseButton from "@/components/newUI/BaseButton";
    import baseRadio from "@/components/newUI/Inputs/BaseRadio";
    import baseCheckbox from "@/components/newUI/Inputs/BaseCheckbox";
    import moneyInput from "@/components/newUI/Inputs/MoneyInput";
    import {Warning} from '@element-plus/icons-vue';
    import {requestFromAWS} from '@/utilFunction';
    import { nextTick, reactive, ref,watch,onMounted,defineProps } from 'vue';
    import { usePaymentScheduleStore } from '@/store/paymentSchedule';
    const util = require('@/utilFunction');
    
    var props = defineProps(['status','save','type']);
    var specialTerms = ref(false);
    var numberOfSchedule = ref(0);
    const installmentMode = ref('month')
    const splitPref = ref('ssd');
    const installmentTitle = ref('Installment (pre Months)');
    var paymentScheduleForm = reactive({campaignPeriod:[],mediaTotal:0,productionTotal:0,mediaOutstanding:0,productionOutstanding:0,description:''});
    var invoiceTerm = reactive([]);
    var paymentTerm = reactive([]);
    var paymentType = reactive([]);
    var initCampaign = {};
    var scheduleData = ref([]);
    var isNew = ref(false);
    var isPrivate = ref(false);
    var isCOD = false;
    var paymentSchedule;
    var businessNature;
    var oneMonthDays = 30;
    const fixDate = ref(1);
    const installmentNumberOf = ref(1);
    const earlyDeposit = ref(0);
    var numberOfScheduleRecord = 0;

    //var endpoint = 'https://zmiz6zzxtv5ug4r4jdled22jg40fpgrj.lambda-url.ap-east-1.on.aws';

    var searchForm = reactive({schedulePeriod:''});

    //requestFromAWS(endpoint,'getTesting');

    function dateDiffInDays(a, b) {
        console.log(a,b);
        if(typeof a === 'string' || a instanceof String){
            a = new Date(util.getJSDate(a));
            b = new Date(util.getJSDate(b));
        }
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY) + 1;
    }

    function dateDiffInDaysTerms(a, b) {
        a = new Date(a);
        b = new Date(b);
        
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }

    function updateNumberOfSchedule(value){
        numberOfSchedule.value = value;
    }

    function getNumberOfTitle(){
        if(paymentScheduleForm.paymentType == 'installment'){
            return installmentMode.value=='month'?'Months':'Days'
        }else{
            return 'Days'
        }
    }

    // onMounted(() => {
    //     const paymentSchedule = usePaymentScheduleStore();
    //     var temp = paymentSchedule.getSummary();
    //     paymentScheduleForm.campaignPeriod = temp.campaignPeriod;
    //     paymentScheduleForm.mediaTotal = temp.mediaTotal;
    //     paymentScheduleForm.productionTotal = temp.productionTotal;
    //     paymentScheduleForm.grandTotal = paymentScheduleForm.mediaTotal + paymentScheduleForm.productionTotal;
    //     console.log(paymentScheduleForm.campaignPeriod);
    //     console.log(props.status);
    //     //console.log(paymentSchedule.getSummary());
    // });

    function init(){
        scheduleData.value = [];
        paymentSchedule = usePaymentScheduleStore();
        var temp = paymentSchedule.getSummary();
        paymentScheduleForm.campaignPeriod = temp.campaignPeriod;
        initCampaign = temp.campaignPeriod;
        paymentScheduleForm.mediaTotal = temp.mediaTotal;
        paymentScheduleForm.productionTotal = temp.productionTotal;
        paymentScheduleForm.contractType = temp.contractType;
        paymentScheduleForm.grandTotal = paymentScheduleForm.mediaTotal.moneyFormatToFloat() + paymentScheduleForm.productionTotal.moneyFormatToFloat();
        if(temp.paymentType){
            paymentScheduleForm.paymentType = temp.paymentType;
        }else{
            paymentScheduleForm.paymentType = 'fullpayment'
        }
        
        invoiceTerm = paymentSchedule.getInvoiceTerm();
        paymentTerm = paymentSchedule.getPaymentTerm();
        paymentType = paymentSchedule.getPaymentType();
        businessNature = paymentSchedule.getBusinessNature();
        isPrivate.value = businessNature=='Private';
        isCOD = dateDiffInDaysTerms(new Date(),paymentScheduleForm.campaignPeriod[0])<=oneMonthDays;
        console.log(props.type);
        console.log(temp);
        
        if(temp.paymentTerm){
            paymentScheduleForm.paymentTerm = temp.paymentTerm;
        }else{
            if(isPrivate.value){
                if(isCOD){
                    paymentScheduleForm.paymentTerm = 'cod';
                }else{
                    paymentScheduleForm.paymentTerm = 'csdm30';
                }
            }else{
                paymentScheduleForm.paymentTerm = 'csda21';
            }
        }
        if(temp.invoiceTerm){
            paymentScheduleForm.invoiceTerm = temp.invoiceTerm;
        }else{
            //'duem14'
            if(isPrivate.value){
                if(isCOD){
                    paymentScheduleForm.invoiceTerm = 'cod';
                }else{
                    paymentScheduleForm.invoiceTerm = 'duem14';
                }
            }else{
                paymentScheduleForm.invoiceTerm = 'ced';
            }
        }
        if(props.type!='new'){
            var tempScheduleData = paymentSchedule.getPaymentScheduleData();
            paymentScheduleForm.paymentType = tempScheduleData[0].PSType;
            paymentScheduleForm.paymentTerm = tempScheduleData[0].PaymentTerm;
            paymentScheduleForm.invoiceTerm = tempScheduleData[0].InvoiceTerm;
            //scheduleData.value = tempScheduleData[0].PaymentDetail;
            
            tempScheduleData[0].PaymentDetail.map(val=>{
                var temp = {};
                temp.no = val.PeriodNo;
                temp.schedule = val.PeriodNo;
                temp.from = util.getDateFormat(val.PaymentFrom);
                temp.to = util.getDateFormat(val.PaymentTo);
                temp.days = val.NoOfDays;
                temp.mediaAmount = util.getMoneyFormat(val.MediaInstallmentAmount);
                temp.productionAmount = util.getMoneyFormat(val.ProductionInstallmentAmount);
                temp.totalAmount = util.getMoneyFormat(val.TotalAmount);
                temp.paymentDueDate = util.getDateFormat(val.PaymentDueDate);
                temp.invoiceDate = util.getDateFormat(val.InvoiceIssueDate);
                temp.paymentStatus = val.PaymentStatus;
                temp.invoiceStatus = val.InvoiceStatus;
                scheduleData.value.push(temp);
            })
            var totalRecord = {};
            totalRecord.mediaAmount = util.getMoneyFormat(paymentScheduleForm.mediaTotal);
            totalRecord.productionAmount = util.getMoneyFormat(paymentScheduleForm.productionTotal);
            totalRecord.totalAmount = util.getMoneyFormat(paymentScheduleForm.grandTotal);
            totalRecord.isTotal = true;
            scheduleData.value.push(totalRecord);
            
            console.log(tempScheduleData[0]);
        }
        
        isNew.value = true;
    }

    function displayStatus(date){
        if(!date){
            return '';
        }
        if(dateDiffInDaysTerms(new Date(),util.getJSDate(date))<=30){
            return 'Immediately'
        }else{
            return 'On Schedule'
        }
        // switch(status){
        //     case 'immediately': return 'Immediately';
        //     case 'notinvoiced': return 'Not Invoiced';
        // }
    }
    function displayInvoiceStatus(status){
        switch(status){
            case 'immediately': return 'Immediately';
            case 'notinvoiced': return 'Not Invoiced';
        }
    }

    function generateSchedule(){
        scheduleData.value = [];
        if(paymentScheduleForm.paymentType == 'fullpayment'){
            var temp = {};
            temp.no = 1;
            temp.schedule = 1;
            temp.from = util.getDateFormat(paymentScheduleForm.campaignPeriod[0]);
            temp.to = util.getDateFormat(paymentScheduleForm.campaignPeriod[1]);
            temp.days = numberOfSchedule.value;
            temp.mediaAmount = util.getMoneyFormat(paymentScheduleForm.mediaTotal);
            temp.productionAmount = util.getMoneyFormat(paymentScheduleForm.productionTotal);
            temp.totalAmount = util.getMoneyFormat(paymentScheduleForm.grandTotal);
            temp.paymentDueDate = getDueDate(paymentScheduleForm.paymentTerm,temp.from,temp.to,'');
            temp.invoiceDate = getDueDate(paymentScheduleForm.invoiceTerm,temp.from,temp.to,temp.paymentDueDate);
            temp.paymentStatus = 'immediately';
            temp.invoiceStatus = 'notinvoiced';
            scheduleData.value.push(temp);
        }else if(paymentScheduleForm.paymentType == 'burst'){
            console.log(JSON.parse(paymentSchedule.contractMedia));
            var media = JSON.parse(paymentSchedule.contractMedia);
            media.sort(function compareFn(a, b) {
                //return b.Id - a.Id;
                return new Date(a.StartDate) - new Date(b.StartDate);
            });
            media.map((val,index)=>{
                console.log(val,index);
                var productionAmount = 0;
                var temp = {};
                temp.no = index + 1;
                temp.schedule = index + 1;
                temp.from = util.getDateFormat(val.StartDate);
                temp.to = util.getDateFormat(val.EndDate);
                temp.days = val.NoOfDays;
                temp.mediaAmount = util.getMoneyFormat(val.NettItemSum);
                if(index==0){
                    productionAmount = val.TotalProductionCost+paymentSchedule.AdditionalProduction;
                }else{
                    productionAmount = val.TotalProductionCost;
                }
                temp.productionAmount = util.getMoneyFormat(productionAmount);
                temp.totalAmount = util.getMoneyFormat(val.NettItemSum+productionAmount);
                temp.paymentDueDate = getDueDate(paymentScheduleForm.paymentTerm,temp.from,temp.to,'');
                temp.invoiceDate = getDueDate(paymentScheduleForm.invoiceTerm,temp.from,temp.to,temp.paymentDueDate);
                temp.paymentStatus = 'immediately';
                temp.invoiceStatus = 'notinvoiced';
                scheduleData.value.push(temp);
            });
        }else if(paymentScheduleForm.paymentType == 'installment'){
            numberOfScheduleRecord = 0;
            var firstFrom = paymentScheduleForm.campaignPeriod[0];
            var totalAmount = paymentScheduleForm.mediaTotal;
            var earlyDepositAmount = 0;
            var productionAmount = 0;
            var mediaAmount = 0;
            var earlyDepositNumber = parseInt(earlyDeposit.value);
            if(installmentMode.value=='month'){
                
                numberOfScheduleRecord = monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]);
                if(earlyDeposit.value!=0){
                    earlyDepositAmount = totalAmount * installmentNumberOf.value / numberOfScheduleRecord * parseInt(earlyDeposit.value);
                    productionAmount = paymentScheduleForm.productionTotal;
                    //totalAmount -= earlyDepositAmount;
                    console.log(totalAmount);
                    firstFrom = adjustDate(firstFrom,'addMonth',(installmentNumberOf.value * earlyDepositNumber));
                    // let empty = {};
                    // scheduleData.value.push(empty);
                }
                //numberOfScheduleRecord = getNumberOfRecord(numberOfSchedule.value);
                //console.log(monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]));
                for(let i=0;i<numberOfScheduleRecord - earlyDepositNumber;i++){
                    let productionAmount = 0;
                    let mediaAmount = 0;
                    if(i==0){
                        if(earlyDepositNumber==0){
                            productionAmount = paymentScheduleForm.productionTotal;
                        }else{
                            productionAmount = 0;
                        }
                        
                    }else{
                        productionAmount = 0;
                    }
                    // if(i == numberOfScheduleRecord-1){

                    // }
                    temp = {};
                    temp.no = i + 1;
                    temp.schedule = i + 1;
                    if(splitPref.value=='fix'){
                        if(i==0){
                            temp.from = adjustDate(firstFrom,'addMonth',installmentNumberOf.value * i);
                        }else{
                            temp.from = fixDateMonth(fixDate.value,firstFrom,installmentNumberOf.value * i);
                        }
                        temp.to = fixDateMonth(fixDate.value,firstFrom,installmentNumberOf.value * (i+1),'to');
                    }else{
                        temp.from = adjustDate(firstFrom,'addMonth',installmentNumberOf.value * i);
                        temp.to = adjustDate(firstFrom,'addMonthForTo',installmentNumberOf.value * (i+1));
                    }
                    if(installmentMode.value == 'month'){
                        temp.days = installmentNumberOf;
                    }
                    mediaAmount = paymentScheduleForm.mediaTotal / numberOfScheduleRecord;
                    temp.mediaAmount = util.getMoneyFormat(mediaAmount);
                    temp.productionAmount = util.getMoneyFormat(productionAmount);
                    temp.totalAmount = util.getMoneyFormat(mediaAmount+productionAmount);
                    temp.paymentDueDate = getDueDate('csdm30',temp.from,temp.to,'');
                    temp.invoiceDate = getDueDate('duem14',temp.from,temp.to,temp.paymentDueDate);
                    temp.paymentStatus = 'immediately';
                    temp.invoiceStatus = 'notinvoiced';
                    scheduleData.value.push(temp);
                }
            }else if(installmentMode.value=='day'){
                //numberOfScheduleRecord = monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]);
                numberOfScheduleRecord = getNumberOfRecord(numberOfSchedule.value,1,installmentNumberOf.value);
                
                
                //console.log(monthDiff(paymentScheduleForm.campaignPeriod[0],paymentScheduleForm.campaignPeriod[1]));
                if(earlyDeposit.value!=0){
                    console.log((paymentScheduleForm.mediaTotal * installmentNumberOf.value / numberOfSchedule.value));
                    earlyDepositAmount = totalAmount * installmentNumberOf.value / numberOfSchedule.value * parseInt(earlyDeposit.value);
                    productionAmount = paymentScheduleForm.productionTotal;
                    //totalAmount -= earlyDepositAmount;
                    console.log(totalAmount);
                    firstFrom = adjustDate(firstFrom,'addDay',(installmentNumberOf.value * earlyDepositNumber)+1);
                    // let empty = {};
                    // scheduleData.value.push(empty);
                }
                console.log(earlyDepositNumber);
                for(let i=0;i<(numberOfScheduleRecord - earlyDepositNumber);i++){
                    temp = {};
                    if(i==0){
                        if(earlyDepositNumber==0){
                            productionAmount = paymentScheduleForm.productionTotal;
                        }else{
                            productionAmount = 0;
                        }
                        temp.from = adjustDate(firstFrom,'addDay',installmentNumberOf.value * i);
                    }else{
                        productionAmount = 0;
                        temp.from = adjustDate(scheduleData.value[i-1].to,'addDay',1);
                    }
                    // if(i == numberOfScheduleRecord-1){

                    // }
                    temp.no = i + 1;
                    temp.schedule = i + 1;
                    temp.to = adjustDate(temp.from,'addDay',parseInt(installmentNumberOf.value) - 1);
                    if(installmentMode.value == 'day'){
                        temp.days = dateDiffInDays(temp.from,temp.to);
                        //installmentNumberOf.value;
                    }
                    console.log((numberOfSchedule.value - earlyDepositNumber));
                    mediaAmount = totalAmount * installmentNumberOf.value / numberOfSchedule.value;
                    temp.mediaAmount = util.getMoneyFormat(mediaAmount);
                    temp.productionAmount = util.getMoneyFormat(productionAmount);
                    temp.totalAmount = util.getMoneyFormat(mediaAmount+productionAmount);
                    temp.paymentDueDate = getDueDate('csdm30',temp.from,temp.to,'');
                    temp.invoiceDate = getDueDate('duem14',temp.from,temp.to,temp.paymentDueDate);
                    temp.paymentStatus = 'immediately';
                    temp.invoiceStatus = 'notinvoiced';
                    scheduleData.value.push(temp);
                }
                if(numberOfSchedule.value % numberOfScheduleRecord != 0){
                    temp = {};
                    temp.from = adjustDate(scheduleData.value[numberOfScheduleRecord - 1 - earlyDepositNumber].to,'addDay',1);
                    temp.no = numberOfScheduleRecord - earlyDepositNumber + 1;
                    temp.schedule = numberOfScheduleRecord - earlyDepositNumber + 1;
                    temp.to = util.getDateFormat(paymentScheduleForm.campaignPeriod[1]);
                    if(installmentMode.value == 'day'){
                        temp.days = dateDiffInDays(temp.from,temp.to);
                        //installmentNumberOf.value;
                    }
                    let mediaAmount = totalAmount * temp.days / numberOfSchedule.value;
                    let productionAmount = 0;
                    temp.mediaAmount = util.getMoneyFormat(mediaAmount);
                    temp.productionAmount = util.getMoneyFormat(productionAmount);
                    temp.totalAmount = util.getMoneyFormat(mediaAmount+productionAmount);
                    temp.paymentDueDate = getDueDate('csdm30',temp.from,temp.to,'');
                    temp.invoiceDate = getDueDate('duem14',temp.from,temp.to,temp.paymentDueDate);
                    temp.paymentStatus = 'immediately';
                    temp.invoiceStatus = 'notinvoiced';
                    scheduleData.value.push(temp);
                }
            }
        }

        var totalRecord = {};
        totalRecord.mediaAmount = util.getMoneyFormat(paymentScheduleForm.mediaTotal);
        totalRecord.productionAmount = util.getMoneyFormat(paymentScheduleForm.productionTotal);
        totalRecord.totalAmount = util.getMoneyFormat(paymentScheduleForm.grandTotal);
        totalRecord.isTotal = true;
        scheduleData.value.push(totalRecord);
        if(earlyDepositNumber!=0){
            var earlyDepositRow = {};
            earlyDepositRow.no = '';
            earlyDepositRow.schedule = 'Early Deposit';
            earlyDepositRow.from = util.getDateFormat(paymentScheduleForm.campaignPeriod[0]);
            if(installmentMode.value=='month'){
                earlyDepositRow.to = adjustDate(paymentScheduleForm.campaignPeriod[0],'addMonthForTo',earlyDepositNumber*parseInt(installmentNumberOf.value));
                //earlyDepositRow.to = adjustDate(paymentScheduleForm.campaignPeriod[0],'addMonth',earlyDepositNumber*parseInt(installmentNumberOf.value));
            }else{
                earlyDepositRow.to = adjustDate(paymentScheduleForm.campaignPeriod[0],'addDay',earlyDepositNumber*parseInt(installmentNumberOf.value));
            }
            
            earlyDepositRow.mediaAmount = util.getMoneyFormat(earlyDepositAmount);
            productionAmount = paymentScheduleForm.productionTotal;
            earlyDepositRow.productionAmount = util.getMoneyFormat(productionAmount);
            earlyDepositRow.totalAmount = util.getMoneyFormat(earlyDepositAmount+productionAmount);
            earlyDepositRow.days = earlyDepositNumber*parseInt(installmentNumberOf.value);
            earlyDepositRow.paymentDueDate = getDueDate('csdm30',earlyDepositRow.from,earlyDepositRow.to,'');
            earlyDepositRow.invoiceDate = getDueDate('duem14',earlyDepositRow.from,earlyDepositRow.to,earlyDepositRow.paymentDueDate);
            scheduleData.value.unshift(earlyDepositRow);
        }
        //scheduleData.value.unshift({});
    }

    function disabledDate(date){
        var start = new Date(initCampaign[0]);
        var end = new Date(initCampaign[1]);
        return date < start || date > end
    }

    function monthDiff(d1, d2) {
        d1 = new Date(d1);
        d2 = new Date(d2);
        var months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months <= 0 ? 0 : months+1;
    }

    function getNumberOfRecord(totalDay,monthSplit=1,splitDay=28){
        return Math.floor(totalDay / (splitDay * monthSplit));
    }

    function getDueDate(term,start,end,due){
        var d;
        switch(term){
            case 'cod': return util.getDateFormat(new Date());
            case 'csdm30':  
                d = new Date(util.getJSDate(start));
                return util.getDateFormat(d.setDate(d.getDate() - 30));
            case 'duem14':  
                d = new Date(util.getJSDate(due));
                return util.getDateFormat(d.setDate(d.getDate() - 14));
        }
    }

    function adjustDate(date,type='addDay',numberOfDate=28){
        var d;
        d = new Date(util.getJSDate(date));
        switch(type){
            case 'addDay': return util.getDateFormat(d.setDate(d.getDate() + numberOfDate));
            case 'addDayAnd1More': return util.getDateFormat(d.setDate(d.getDate() + numberOfDate + 1));
            case 'minusDay':return util.getDateFormat(d.setDate(d.getDate() - numberOfDate));
            case 'addMonth': return util.getDateFormat(d.setMonth(d.getMonth() + numberOfDate));
            case 'minusMonth':return util.getDateFormat(d.setMonth(d.getMonth() - numberOfDate));
            case 'addMonthForTo': d.setMonth(d.getMonth() + numberOfDate);d.setDate(d.getDate() - 1);return util.getDateFormat(d);
        }
    }

    function fixDateMonth(fixDate,date,month,type='from'){
        var d = new Date(util.getJSDate(date));
        if(d.getDate()<fixDate){
            d.setMonth(d.getMonth() + month - 1)
        }else{
            d.setMonth(d.getMonth() + month + 1)
        }
        if(type=='from'){
            d.setDate(fixDate);
        }else{
            d.setDate(fixDate);
            d.setDate(d.getDate() - 1);
        }
        
        return util.getDateFormat(d);
    }


    /*
        ${data.paymentSummary.contractId},
        '${data.paymentSummary.campaignStart}',
        '${data.paymentSummary.campaignEnd}',
        ${data.paymentSummary.days},
        ${data.paymentSummary.totalMediaAmount},
        ${data.paymentSummary.totalProductionAmount},
        ${data.paymentSummary.totalOutstandingMedia},
        ${data.paymentSummary.totalOutstandingProduction},
        '${data.paymentSummary.Currency}',
    */

   /*
        '${data.paymentSchedule.contractType}',
        '${data.paymentSchedule.contractAction}',
        ${data.paymentSchedule.contractId},
        ${data.paymentSchedule.campaignStart},
        ${data.paymentSchedule.campaignEnd},
        ${data.paymentSchedule.days},
        ${data.paymentSchedule.numOfSchedule},
        ${data.paymentSummary.scheduleMedia},
        ${data.paymentSummary.scheduleProduction},
        ${data.paymentSummary.totalScheduleAmount},
        ${data.paymentSummary.paidAmount},
        '${data.paymentSchedule.psType}',
        '${data.paymentSchedule.paymentTerm}',
        '${data.paymentSchedule.invoiceTerm}',
        '${data.paymentSchedule.description}',
        0,
        '${data.paymentSchedule.currency}',

        ${i+1},
        '${i+1}',
        '${data.paymentScheduleDetail[i].from}',
        '${data.paymentScheduleDetail[i].to}',
        ${data.paymentScheduleDetail[i].days},
        ${data.paymentScheduleDetail[i].mediaAmount},
        ${data.paymentScheduleDetail[i].productionAmount},
        ${data.paymentScheduleDetail[i].mediaAmount + data.paymentScheduleDetail[i].productionAmount},
        '${data.paymentScheduleDetail[i].paymentDue}',
        '${data.paymentScheduleDetail[i].invoiceDue}',
        '${data.paymentScheduleDetail[i].paymentStatus}',
        '${data.paymentScheduleDetail[i].invoiceStatus}',
   */
    function newPaymentSchedule(){
        var param = {paymentSummary:{},paymentSchedule:{},paymentScheduleDetail:[]};
        console.log(scheduleData);
        scheduleData.value.map(val=>{
            var temp = {};
            if(val.from){
                temp.from = util.getJSDateForDB(val.from);
                temp.to = util.getJSDateForDB(val.to);
                temp.days = dateDiffInDays(util.getJSDate(val.from),util.getJSDate(val.to));
                temp.mediaAmount = val.mediaAmount.replace(/[^^0-9.]/g,'');
                temp.productionAmount = val.productionAmount.replace(/[^^0-9.]/g,'');
                temp.totalAmount = val.totalAmount.replace(/[^^0-9.]/g,'');
                temp.paymentDue = util.getJSDateForDB(val.paymentDueDate);
                temp.invoiceDue = util.getJSDateForDB(val.invoiceDate);
                temp.paymentStatus = val.paymentStatus;
                temp.invoiceStatus = val.invoiceStatus;
                param.paymentScheduleDetail.push(temp);
            }
        })
        console.log(param.paymentScheduleDetail);
        //temp.from = 
        param.paymentSchedule.contractType = paymentScheduleForm.contractType;
        param.paymentSchedule.contractAction = paymentScheduleForm.contractType;
        param.paymentSchedule.contractId = paymentScheduleForm.contractId;
        param.paymentSchedule.campaignStart = paymentScheduleForm.campaignPeriod[0];
        param.paymentSchedule.campaignEnd = paymentScheduleForm.campaignPeriod[1];
        param.paymentSchedule.days = numberOfSchedule.value;
        param.paymentSchedule.numOfSchedule = numberOfScheduleRecord;
        param.paymentSchedule.scheduleMedia = paymentScheduleForm.mediaTotal;
        param.paymentSchedule.scheduleProduction = paymentScheduleForm.productionTotal;
        param.paymentSchedule.totalScheduleAmount = paymentScheduleForm.mediaTotal + paymentScheduleForm.productionTotal;
        param.paymentSchedule.paidAmount = 0;
        param.paymentSchedule.psType = paymentScheduleForm.paymentType;
        param.paymentSchedule.paymentTerm = paymentScheduleForm.paymentTerm;
        param.paymentSchedule.invoiceTerm = paymentScheduleForm.invoiceTerm;
        param.paymentSchedule.description = paymentScheduleForm.description;
        param.paymentSchedule.currency = 'HKD';
        


        param.paymentSummary.contractId = paymentScheduleForm.contractId;
        param.paymentSummary.campaignStart = paymentScheduleForm.campaignPeriod[0];
        param.paymentSummary.campaignEnd = paymentScheduleForm.campaignPeriod[1];
        param.paymentSummary.days = numberOfSchedule.value;
        param.paymentSummary.totalMediaAmount = paymentScheduleForm.mediaTotal;
        param.paymentSummary.totalProductionAmount = paymentScheduleForm.productionTotal;
        param.paymentSummary.totalOutstandingMedia = paymentScheduleForm.mediaTotal;
        param.paymentSummary.totalOutstandingProduction = paymentScheduleForm.productionTotal;
        param.paymentSummary.Currency = 'HKD';

        param.userCode = 'admin';
        param.userName = 'Admin';
        util.loading();
        util.requestFromAWSWithData(util.dev_endpoint,'savePaymentSchedule',param).then(val=>{
            console.log(val);
            util.closeLoading();
        });
    }

    watch(
        () => paymentScheduleForm.campaignPeriod,
        (value, oldValue) => {
            if(value){
                if(value[0] && value[1]){
                    updateNumberOfSchedule(dateDiffInDays(value[0],value[1]));
                }
                //console.log(dateDiffInDays(value[0],value[1]), oldValue)
            }
        }, {immediate:true},
    )
    watch(
        () => props.status,
        (value, oldValue) => {
            if(value){
                init();
            }
        }, {immediate:true},
    )

    watch(
        () => props.save,
        (value, oldValue) => {
            if(value){
                newPaymentSchedule();
                props.save = false;
                console.log(value);
            }
        }, {immediate:true},
    )

    watch(
        () => paymentScheduleForm.mediaTotal,
        (value, oldValue) => {
            paymentScheduleForm.grandTotal = value.moneyFormatToFloat() + paymentScheduleForm.productionTotal.moneyFormatToFloat();
        }, {immediate:true},
    )
    watch(
        () => paymentScheduleForm.productionTotal,
        (value, oldValue) => {
            paymentScheduleForm.grandTotal = paymentScheduleForm.mediaTotal.moneyFormatToFloat() + value.moneyFormatToFloat();
        }, {immediate:true},
    )

    watch(
        () => installmentMode.value,
        (value, oldValue) => {
            console.log(value);
            if(value == 'month'){
                installmentTitle.value = 'Installment (pre Months)';
                installmentNumberOf.value = 1;
            }else{
                installmentTitle.value = 'Installment (pre Days)';
                splitPref.value = 'ssd';
                installmentNumberOf.value = 28;
            }
        }, {immediate:true},
    )
    
</script>
<style scoped>
.special-terms-days .el-input__wrapper .el-input__inner{
    padding: 0px!important;
}
.form-check-sign{
    top: -9px;
    left: -6px;
}
</style>